<template>
  <el-dialog
    :title="isUpdate ? '修改字典' : '添加字典'"
    :visible="visible"
    width="440px"
    :destroy-on-close="true"
    :lock-scroll="false"
    @update:visible="updateVisible">
    <el-form ref="form" :model="form" :rules="rules" label-width="82px">
      <el-form-item label="字典名称:" prop="name">
        <el-input v-model="form.name" maxlength="20" clearable placeholder="请输入" />
      </el-form-item>
      <el-form-item label="字典编码:" prop="code">
        <el-input v-model="form.code" maxlength="50" clearable placeholder="请输入" />
      </el-form-item>
      <el-form-item label="排序号:" prop="sort">
        <el-input-number
          v-model="form.sort"
          :min="0"
          :max="9999"
          controls-position="right"
          class="ele-fluid ele-text-left" />
      </el-form-item>
      <el-form-item label="备注:">
        <el-input v-model="form.note" type="textarea" :rows="3" maxlength="200" placeholder="请输入" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
const defaultForm = () => ({
  name: '',
  code: '',
  sort: 0,
  note: ''
});

export default {
  name: 'DictEdit',
  props: {
    visible: Boolean,
    data: Object
  },
  data() {
    return {
      form: defaultForm(),
      rules: {
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        code: [{ required: true, message: '请输入', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      loading: false,
      isUpdate: false
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm();
      }
    },
    data() {
      if (this.visible) {
        this.initForm();
      }
    }
  },
  methods: {
    initForm() {
      if (this.data && Object.keys(this.data).length) {
        this.form = Object.assign(defaultForm(), this.data);
        this.isUpdate = true;
      } else {
        this.form = defaultForm();
        this.isUpdate = false;
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.loading = true;
        this.$http.post('/dict/edit', this.form).then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.updateVisible(false);
            this.$emit('done');
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
      });
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    }
  }
};
</script>
